// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import '@/styles/configure.scss'
import Vue from 'vue'
import VueMoment from 'vue-moment'
import VueLocalStorage from 'vue-localstorage'
import VTooltip from 'v-tooltip'
import VueAnalytics from 'vue-analytics'
import VueVisibility from 'vue-visibility-change'
import VueNativeSock from 'vue-native-websocket'
import App from './App'
import store from './store'
import router from './router'
import config from '@/api/config'
import socket from './socket'
import VueIntercom from 'vue-intercom'
import VueClipboard from 'vue-clipboard2'
import VueI18n from 'vue-i18n'
import hvI18n from './i18n'
import VueMeta from 'vue-meta'
import VueBbob from '@bbob/vue2'

Vue.use(VueBbob)
Vue.config.productionTip = false
Vue.use(VueLocalStorage)
Vue.use(VueMoment)
Vue.use(VTooltip)
Vue.use(VueVisibility)
Vue.use(VueMeta)

if (!window.location.pathname.includes('/widget')) {
  Vue.use(VueAnalytics, {
    id: config.googleAnalytics,
    checkDuplicatedScript: true,
    router,
    autoTracking: {
      screenview: true
    },
    debug: {
      sendHitTask: process.env.NODE_ENV === 'production'
    }
  })
  Vue.use(VueIntercom, { appId: 'z5rmqdbc' })
}
Vue.use(VueClipboard)

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  messages: hvI18n
})

const wsProto = window.location.protocol.includes('https') ? 'wss' : 'ws'

Vue.use(VueNativeSock, `${wsProto}://${window.location.host}/websocket`, {
  format: 'json',
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
  store: store,
  passToStoreHandler: socket.handler
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js